import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaGridItem {
  constructor() {
    this.order = undefined;
    this.classes = undefined;
    this.styles = undefined;
  }
  render() {
    return (h(Host, { class: `${this.classes ? this.classes : ''} ${this.getCssClassMap()}` }, this.styles && h("style", null, this.styles), h("slot", null)));
  }
  getCssClassMap() {
    return classNames(this.order && `grid-item-order-${this.order}`);
  }
  static get is() { return "aiba-grid-item"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-grid-item.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-grid-item.css"]
    };
  }
  static get properties() {
    return {
      "order": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "order",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-grid-item.js.map
